import React from "react";
import { map } from "lodash";
import style from "./L1.module.scss";
export var L1 = function L1(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: style.L1box
  }, /*#__PURE__*/React.createElement("div", {
    className: style.L1
  }, map(props.item.lis, function (content, key) {
    var _props$readonlyStyle;
    return /*#__PURE__*/React.createElement("div", {
      style: (_props$readonlyStyle = props.readonlyStyle) !== null && _props$readonlyStyle !== void 0 ? _props$readonlyStyle : {},
      key: "".concat(content).concat(key)
    }, /*#__PURE__*/React.createElement("span", null, content));
  })));
};